module.exports = __webpack_public_path__ + "static/media/rare-whiskies-1.d7ecf9c0.jpg";